export default "__VITE_ASSET__CHd65UEq__"